const BodyFeatures = ({ features }) => {
  const features_rest = features;

  const features_list = []
  features_rest.map((feature) => {
    features_list.push(feature.name)
  });

  const first = features_list.filter((e, index) => {
    return ++index <= Math.trunc(features.length / 2);
  });
  const second = features_list.filter((e, index) => {
    return ++index > Math.trunc(features.length / 2);
  });

  return (
    <div>
      <div className="container p-0">
        <h3 className='text-black mt-5'>Características</h3>
        <div className="body-features-grid text_body_p">
          <div>
            <ul className="pl-1">
              {first.map((item) => (
                <li key={item} className="subhead-regular text-black">{item}</li>
              ))}
            </ul>
          </div>
          <div>
            <ul className="">
              {second.map((item) => (
                <li key={item} className="subhead-regular text-black">{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BodyFeatures;
